<router-outlet></router-outlet>

<body>
  <div class="flex justify-content-between flex-wrap" style="margin-bottom: 35px;">
    <div class="col-3">
      <span style="font-size: 24px; font-weight: 600;">Vehicle Service Providers</span>
    </div>
    <app-permission-wrapper permission="CanAddServiceProvider">
      <div class="p-col-3" style="text-align:right; cursor: pointer;" [routerLink]="['add-vehicle-service-provider']">
        <button type="button" class="add-button btn-primary" pButton>
          <i class="pi pi-plus" style="vertical-align: middle;"></i>
          <span style="margin-left: 8px;">Add Vehicle Service Provider</span>
        </button>
      </div>
    </app-permission-wrapper>
  </div>

  <p-tabView (onChange)="onTabChange($event)">
    <p-tabPanel [header]="'Submitted (' + submittedCount + ')'" pRipple>
      <app-service-provider-status #submittedTab [status]="1"></app-service-provider-status>
    </p-tabPanel>
    <p-tabPanel [header]="'In review (' + inReviewCount + ')'" pRipple>
      <app-service-provider-status #inReviewTab [status]="2"></app-service-provider-status>
    </p-tabPanel>
    <p-tabPanel [header]="'Approved (' + approvedCount + ')'" pRipple>
      <app-service-provider-status #approvedTab [status]="3"></app-service-provider-status>
    </p-tabPanel>
    <p-tabPanel [header]="'Rejected (' + rejectedCount + ')'" pRipple>
      <app-service-provider-status #rejectedTab [status]="4"></app-service-provider-status>
    </p-tabPanel>
  </p-tabView>
</body>
<app-add-sp (updateProviderList)="updateListOnPaymentSuccess()" *ngIf="showModal"
  (closeDialog)="closeAddDialog()"></app-add-sp>